// extracted by mini-css-extract-plugin
var _1 = "Zk1cXj_dJ3LVO8qnuqYa";
var _2 = "j1p1dBOXGWzO38V7YpOM";
var _3 = "GMrJ7ngK6ks_JQNFxyVm";
var _4 = "TbS9YyycCgtvJoQzOOrL";
var _5 = "O_TYC6MRzVudHEonnB6c";
var _6 = "iMOtAhwy3Ek4c0EHylsz";
var _7 = "HP4diJFGX8xz2WITBOP0";
export { _1 as "bg-ddu-blue-600", _2 as "bg-gray", _3 as "mode-toggle", _4 as "switch", _5 as "switch-button", _6 as "switch-label", _7 as "translate-x-5" }
